// Fields to audit across Fund Overview (text/state changes — fill state tracked).
export const FO_AUDIT_FIELDS: { key: string; label: string }[] = [
  { key: "fund_overview_fund_name", label: "Fund Name" },
  { key: "fund_overview_name_of_general_partner", label: "General Partner" },
  { key: "fund_overview_manager", label: "Manager" },
  { key: "fund_overview_legal_form", label: "Legal Form" },
  { key: "fund_overview_fund_investment_state", label: "Status" },
  { key: "fund_overview_fund_domicile", label: "Domicile" },
  { key: "fund_overview_team_location_country", label: "Team Location" },
  { key: "fund_overview_currency_of_the_fund", label: "Currency" },
  { key: "fund_overview_reporting_currency_fund", label: "Reporting Currency" },
  { key: "fund_overview_vintage_year", label: "Vintage Year" },
  { key: "fund_overview_generation", label: "Generation" },
  { key: "fund_overview_commitment_date", label: "Commitment Date" },
  { key: "fund_overview_signature_date", label: "Signature Date" },
  { key: "fund_overview_first_closing_date", label: "First Closing" },
  { key: "fund_overview_final_closing_date", label: "Final Closing" },
  { key: "fund_overview_first_investment_date", label: "First Investment" },
  {
    key: "fund_overview_end_of_investment_period",
    label: "End of Inv. Period",
  },
  { key: "fund_overview_planned_end_date", label: "Planned End" },
  { key: "fund_overview_liquidation_date", label: "Liquidation Date" },
  { key: "fund_overview_asset_type", label: "Asset Type" },
  { key: "fund_overview_product_type", label: "Product Type" },
  { key: "fund_overview_strategy_focus", label: "Strategy Focus" },
  { key: "fund_overview_sector_focus", label: "Sector Focus" },
  { key: "fund_overview_geographic_focus", label: "Geographic Focus" },
  {
    key: "fund_overview_pct_of_private_investors",
    label: "% Private Investors",
  },
  { key: "fund_overview_in_which_closing_joined", label: "Joined Closing" },
  { key: "fund_overview_lei_code", label: "LEI Code" },
];

// Portfolio — General Information (text fields, track fill state).
export const PORTFOLIO_GENINFO_FIELDS: { key: string; label: string }[] = [
  {
    key: "portfolio_review_general_information_company_name_long_name",
    label: "Company Name",
  },
  {
    key: "portfolio_review_general_information_company_name_short_name",
    label: "Short Name",
  },
  {
    key: "portfolio_review_general_information_company_website",
    label: "Website",
  },
  {
    key: "portfolio_review_general_information_legal_form",
    label: "Legal Form",
  },
  {
    key: "portfolio_review_general_information_geography_legal_country",
    label: "Country",
  },
  {
    key: "portfolio_review_general_information_city_of_the_legal_country",
    label: "City",
  },
  { key: "portfolio_review_general_information_nace_code", label: "NACE Code" },
  {
    key: "portfolio_review_general_information_commercial_register_number",
    label: "Reg. Number",
  },
  { key: "portfolio_review_general_information_lei_code", label: "LEI Code" },
  {
    key: "portfolio_review_general_information_seedpool_fund_investments",
    label: "Seedpool",
  },
  {
    key: "portfolio_review_general_information_short_description_of_the_business",
    label: "Description",
  },
  { key: "portfolio_review_general_information_comment", label: "Comment" },
  {
    key: "portfolio_review_general_information_stage_at_initial_investment",
    label: "Entry Stage",
  },
  {
    key: "portfolio_review_general_information_last_investment_stage",
    label: "Last Stage",
  },
];

// Portfolio — Numeric position fields (flag big % changes).
export const PORTFOLIO_NUMERIC_FIELDS: { key: string; label: string }[] = [
  { key: "portfolio_review_portfolio_positions_turnover", label: "Turnover" },
  { key: "portfolio_review_portfolio_positions_ebitda", label: "EBITDA" },
  {
    key: "portfolio_review_portfolio_positions_total_investment_cost",
    label: "Total Investment Cost",
  },
  {
    key: "portfolio_review_portfolio_positions_current_costs",
    label: "Current Costs",
  },
  {
    key: "portfolio_review_portfolio_positions_fair_value",
    label: "Fair Value",
  },
  { key: "portfolio_review_portfolio_positions_proceeds", label: "Proceeds" },
  {
    key: "portfolio_review_portfolio_positions_dividends_income",
    label: "Dividends",
  },
  { key: "portfolio_review_portfolio_positions_irr_pct", label: "Gross IRR" },
  {
    key: "portfolio_review_portfolio_positions_moic_mult",
    label: "Gross MOIC",
  },
  {
    key: "portfolio_review_portfolio_positions_ownership_non_diluted_pct",
    label: "Ownership % (ND)",
  },
  {
    key: "portfolio_review_portfolio_positions_ownership_fully_diluted_pct",
    label: "Ownership % (FD)",
  },
  {
    key: "portfolio_review_portfolio_positions_realized_costs_incl_partial_realisation",
    label: "Realized Costs",
  },
];

// Portfolio — Critical numeric fields whose emptiness should always be flagged.
export const PORTFOLIO_CRITICAL_FIELDS: { key: string; label: string }[] = [
  { key: "portfolio_review_portfolio_positions_ebitda", label: "EBITDA" },
  {
    key: "portfolio_review_portfolio_positions_fair_value",
    label: "Fair Value",
  },
  {
    key: "portfolio_review_portfolio_positions_total_investment_cost",
    label: "Total Investment Cost",
  },
  { key: "portfolio_review_portfolio_positions_turnover", label: "Turnover" },
  {
    key: "portfolio_review_portfolio_positions_ownership_non_diluted_pct",
    label: "Ownership %",
  },
];
